var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPrivacy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PRIVACY"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0515 8.70041L17.2348 12.1837C16.5348 15.1921 15.1515 16.4087 12.5515 16.1587C12.1348 16.1254 11.6848 16.0504 11.2015 15.9337L9.80145 15.6004C6.32645 14.7754 5.25145 13.0587 6.06812 9.57541L6.88479 6.08375C7.05145 5.37541 7.25145 4.75875 7.50145 4.25041C8.47645 2.23375 10.1348 1.69208 12.9181 2.35041L14.3098 2.67541C17.8015 3.49208 18.8681 5.21708 18.0515 8.70041Z",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5346 7.10833L14.5763 8.13333M9.71793 10.3333L12.1346 10.95M12.5513 16.1583C12.0346 16.5083 11.3846 16.8 10.5929 17.0583L9.27626 17.4917C5.96793 18.5583 4.22626 17.6667 3.15126 14.3583L2.08459 11.0667C1.01793 7.75833 1.90126 6.00833 5.20959 4.94167L6.52626 4.50833C6.86793 4.4 7.19293 4.30833 7.50126 4.25C7.25126 4.75833 7.05126 5.375 6.88459 6.08333L6.06793 9.575C5.25126 13.0583 6.32626 14.775 9.80126 15.6L11.2013 15.9333C11.6846 16.05 12.1346 16.125 12.5513 16.1583Z",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrivacy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/privacy.05b24a18.svg";
export { ForwardRef as ReactComponent };